import { AlertCircle, X } from 'lucide-react';

import { Button } from '@accio3d/design-system/button';

import { clearAgentError, useAgentError } from './agent-error-store';

export function AgentError() {
  const error = useAgentError();

  if (!error) return null;
  return (
    <div
      role="alert"
      className="flex items-start gap-1.5 border-t border-destructive/30 bg-destructive/5 px-3 py-2 text-xs text-destructive"
    >
      <AlertCircle aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <p className="min-w-0 flex-1 wrap-break-word">{error.message}</p>
      <Button
        size="icon"
        variant="ghost"
        aria-label="Dismiss this error"
        className="h-5 w-5 shrink-0 text-destructive"
        onClick={() => clearAgentError()}
      >
        <X className="h-3 w-3" />
      </Button>
    </div>
  );
}
